import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Collab, Campaign, Client } from '@foodfluence/shared';
import type { CardCta } from '@foodfluence/shared';
import CollabCard from './CollabCard';

interface PastCollabCardProps {
  collab: Collab;
  campaign: Campaign;
  client: Client | undefined;
  cta: CardCta;
}

const PastCollabCard: React.FC<PastCollabCardProps> = ({ collab, campaign, client, cta }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/collabs/collab-details/${collab.id}`);
  };

  return (
    <CollabCard
      collab={collab}
      campaign={campaign}
      client={client}
      cta={cta}
      onClick={handleClick}
    />
  );
};

export default PastCollabCard;
